import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import _ from 'lodash';
import VerticalLabelList from '../../../../label/VerticalLabelList';
import FieldSet from '../../../../fieldset/FieldSet';
import '../UtilityView.css';
import Grid from '../../../../grid/Grid';

class OkDmvDetailedRenewal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  formatList(items = []) {
    return items.map((item) => {
      const ref = { ...item, };
      ref.label = item.key;
      ref.value = item.value;
      return ref;
    });
  }

  render() {
    const { renewal, } = this.props;
    const { registration, } = renewal;
    const { registrationFeeBreakdown = [], } = registration;

    const renewalItems = VerticalLabelList.toList({
      'Plate Number': registration.plateNumber,
      'Vehicle Type': registration.vehicleType,
      'Vehicle Identification Number': registration.vehicleIdentificationNumber,
      'Vehicle Year': registration.vehicleModelYear,
      'Vehicle Make': registration.vehicleMake,
      'Vehicle Model': registration.vehicleModel,
      'Vehicle Color': registration.vehicleColor,
      'Non Working Vehicle': registration.nonWorkingVehicle,
      'Farm Vehicle': registration.farmVehicle,
      'Commercial Vehicle': registration.commercialVehicle,
      Trailer: registration.trailer,
      'Registration Expiration Date': moment(registration.registrationExpirationDate).utc().format(),
      'Plate Change': registration.changePlate,
      'County Code': registration.countyCode,
      Subtotal: registration.subtotal,
    });

    const ownerItems = VerticalLabelList.toList({
      'First Name': renewal.citizenContactInfo.firstName,
      'Last Name': renewal.citizenContactInfo.lastName,
      'Phone Number': renewal.citizenContactInfo.phoneNumber,
      'Email Address': registration.emailAddress,
      'Street Address': registration.streetAddress,
      City: registration.city,
      State: registration.state,
      Zipcode: registration.zip,
    });

    const transactionItems = VerticalLabelList.toList({
      'Transaction Id': renewal.transactionId,
      'Transaction Line Item Id': renewal.transactionLineItemId,
      'Customer Id': renewal.customerId,
      Refunded: renewal.refunded,
      'Ach Failure': renewal.achFailure,
      'Transaction Reversed On': renewal.transactionReversedOn,
    });

    const integrationItems = VerticalLabelList.toList({
      'Persisted To Ok': renewal.persistedToOk,
      'Persisted Timestamp': renewal.persistedTimestamp,
    });

    const feeBreakdownModel = Grid.toModelFromList(registrationFeeBreakdown, {
      headerFormatter: value => _.startCase(value.header),
    });

    return (
      <div>
        <div className="column-2" style={{ marginTop: '50px', }}>
          <FieldSet title="Renewal Information">
            <VerticalLabelList
              items={renewalItems}
            />
          </FieldSet>
        </div>

        <div className="column-2" style={{ marginTop: '20px', }}>
          <FieldSet title="Owner Information">
            <VerticalLabelList
              items={ownerItems}
            />
          </FieldSet>
        </div>

        <div className="column-2" style={{ marginTop: '20px', }}>
          <FieldSet title="Transaction Information">
            <VerticalLabelList
              items={transactionItems}
            />
          </FieldSet>
        </div>

        <div className="column-2" style={{ marginTop: '20px', }}>
          <FieldSet title="Integration Information">
            <VerticalLabelList
              items={integrationItems}
            />
          </FieldSet>
        </div>

        <div className="column-2" style={{ marginTop: '20px', }}>
          <FieldSet title="Registration Fee Breakdown">
            <Grid
              headers={feeBreakdownModel.headers}
              rows={feeBreakdownModel.format(this.formatList(registrationFeeBreakdown))}
            />
          </FieldSet>
        </div>
      </div>
    );
  }
}

OkDmvDetailedRenewal.propTypes = {
  renewal: PropTypes.instanceOf(Object).isRequired,
};

export default OkDmvDetailedRenewal;
